import script from "./ViewCreateAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewCreateAccount.vue?vue&type=script&setup=true&lang=js"

import "./ViewCreateAccount.vue?vue&type=style&index=0&id=6888350b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6888350b"]])

export default __exports__